/**
 * VERBIS Service Layer
 * Rule: Business logic, validation, and API orchestration
 * Rule: NO UI IN SDK
 */
import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class VerbisService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getStatus() {
        try {
            const response = await withRetry(() => this.api.getStatus(), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch VERBIS status');
        }
    }

    async getExport() {
        try {
            const blob = await this.api.getExport();
            return { success: true, data: blob };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch VERBIS export');
        }
    }

    async markSynced(data = {}) {
        try {
            const response = await this.api.markSynced(data);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to record VERBIS sync');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
